import { render } from "./fieldGroup.vue?vue&type=template&id=59871f3d&scoped=true"
import script from "./fieldGroup.vue?vue&type=script&lang=js"
export * from "./fieldGroup.vue?vue&type=script&lang=js"

import "./fieldGroup.vue?vue&type=style&index=0&id=59871f3d&scoped=true&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59871f3d"]])

export default __exports__